<template>
<div class="section">
    <div class="container">

        <h1 class="main-headings"><span>Contact</span> Us</h1>
        <div class="contact-wrapper flex justify-btw">
            <div class="address-box">
                <h2> Address </h2>
                <div class="address">
                    <div class="flex align-center">
                        <div class="icon-sprite location"></div>
                        <span>  USA </span>
                    </div>
                    <p>Forever Technologies Inc. 1218 ELM Ridge Avenue, Baltimore 2129,
                    <br />
                        +144 7392743
                    </p>
                </div>
                <div class="address">
                    <div class="flex align-center">
                        <div class="icon-sprite location"></div>
                        <span> India </span>
                    </div>
                    <p> Forever Technologies Pvt. Ltd, No.81, Habibullah Road, T.Nagar, Chennai-600017.
                        <br />
                        +91 99400 35446
                    </p>
                </div>
                <h2 class="email-heading">Email</h2>
                <a href="mailto:support@forevertechnologies.biz">
                    support@forevertechnologies.biz
                </a>
            </div>
            <form @submit.prevent="sendMail">

                <h2>Quick Enquiry</h2>

                <div class="form-element">
                    <input
                        type="text" data-name="Name" data-len="4"
                        id="name" class="form-input" name="name"
                        placeholder="Name" v-model="name"
                        @input="handleInput" @blur="validateFields">
                </div>
                <div class="form-element">
                    <input
                        type="text" data-name="Email" data-len="6"
                        id="email" class="form-input" name="email"
                        placeholder="Email" v-model="email"
                        @input="handleInput" @blur="validateEmail">
                </div>
                <div class="form-element">
                    <input
                        type="number" data-name="Phone Number" data-len="10"
                        id="phone-number" class="form-input" name="phone"
                        placeholder="Phone Number" v-model="phone"
                        @input="handleInput" @blur="validateFields">
                </div>
                <div class="form-element">
                    <textarea
                        type="text" data-name="Messsge" data-len="10"
                        id="message" class="form-textarea" name="message"
                        placeholder="Message" v-model="message"
                        @input="handleInput" @blur="validateFields">
                    </textarea>
                </div>

                <button class="btn fancy-btn submit-btn">
                    Submit
                </button>
            </form>
        </div>

    </div>
</div>
</template>

<script>
import $ from 'jquery';
import emailjs from 'emailjs-com';

export default {
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            message: ''
        }
    },
    methods: {
        handleInput(e)
        {
            if( e.target.value === '' )
                this.addErrorMessage( e.target.id );
            else
                this.removeErrorMessage( e.target.id );
        },
        validateFields({target: el})
        {
            const { name, len } = el.dataset;
            if(el.value === '')
                this.addErrorMessage( el.id );
            else if( el.value.length < len )
                this.addErrorMessage( el.id, `${name} must have atleast ${len} digits.`);
        },
        validateEmail({target: el})
        {
            if(el.value === '')
                return this.addErrorMessage( el.id );

            var atposition = el.value.indexOf("@");
            var dotposition = el.value.lastIndexOf(".");

            if( atposition<1 || dotposition<atposition+2 || dotposition+2>=el.value.length)
                this.addErrorMessage( el.id, `Email invalid.`);
        },
        addErrorMessage( id, msg )
        {
            $(`.${id}-error-msg`).remove();
            var contents;
            if(msg)
                contents = `<p class="error-msg ${id}-error-msg">${msg}</p>`;
            else
                contents = `<p class="error-msg ${id}-error-msg">${$(`#${id}`).data('name')} can't be empty. </p>`;
            $(`#${id}`).parent().addClass('error-parent').append(contents);
        },
        removeErrorMessage(id)
        {
            $(`.${id}-error-msg`).remove();
            $(`#${id}`).parent().removeClass('error-parent');
        },
        isEmailInValid (email)
        {
            var atposition = email.indexOf("@");
            var dotposition = email.lastIndexOf(".");

            if( atposition<1 || dotposition<atposition+2 || dotposition+2>=email.length)
                return true;

            return false;
        },
        async sendMail(e)
        {
            if( this.name === '' )
                this.addErrorMessage('name');
            else if( this.name.length < 4 )
                this.addErrorMessage('name', 'Name must have atleast 6 chars.' );

            if( this.email === '' )
                this.addErrorMessage('email');
            else if( this.isEmailInValid( this.email ) )
                this.addErrorMessage('email','Email must have atleast 6 chars.');

            if( this.phone === '' )
                this.addErrorMessage('phone-number');
            else if( this.phone < 10 )
                this.addErrorMessage('phone-number','Password must have atleast 6 chars.');

            if( this.message === '' )
                this.addErrorMessage('message');
            else if( this.message.length < 6 )
                this.addErrorMessage('message','Message must have atleast 10 chars.');

            if( $('.error-msg').length ) return;
            $('.submit-btn').blur();
            $('.submit-btn').html(`<div class="spinner-border" role="status"></div>`);
            try
            {
                var resp = await emailjs.sendForm('service_wz6x4i4', 'template_zexd9zg', e.target,
                    'user_6ulLFeG7s8CNdYMyREjTs', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    });
                if( resp.status === 200 )
                {
                    this.name = '';
                    this.email = '';
                    this.phone = '';
                    this.message = '';
                    alert('Email Sent!..');
                    $('.submit-btn').html(`Submit`);
                }
                else
                {
                    alert('Error! Try Again..');
                }
            } catch(error)
            {
                console.log(error);
            }
        }
    }
}
</script>

<style scoped>

.address .flex { justify-content: center; }

.address span
{
    color: #00C7FF;
    font-size: 18px;
    font-weight: 600;
}

.address p, a
{
    color: #000;
    font-size: 16px;
    font-weight: 600;
    max-width: 400px;
    text-align: center;
    line-height: 2;
    margin: 5px auto 0;
}

.location
{
    background-size: 301.5px 106.5px;
    background-position: -101.3px -70.5px;
	height: 27px; width: 22.5px;
    margin-right: 20px;
}

.address { margin-top: 50px; }

form, .address-box
{
    flex-direction: column;
    padding: 50px 40px;
    background-color: #fff;
    border-radius: 12px;
    overflow: hidden;
    width: 450px;
    box-shadow: 0px 0px 8px rgb(0, 0, 0,0.2);
}

h2
{
    font-weight: 700;
    font-size: 22px;
    margin-bottom: 30px;
    text-align: center;
    text-transform: uppercase;
}

.email-heading
{
    margin-top: 50px;
    margin-bottom: 25px;
}

a { text-align: center; display: block; color: #00c7ff; }

.form-element
{
    position: relative;
    margin-bottom: 25px;
}

.form-input, textarea
{
    height: 50px; width: 100%;
    padding-left: 18px;
    background-color: #fff;
    border: 2px solid black;
    box-shadow: 3px 3px 4px 0 rgb(0, 0, 0,0.12);
    outline: 0;
    font-size: 16px;
    font-weight: 500;
    color: #000;
    border-radius: 5px;
}

.form-input:focus { border-color: #00c7ff; }

textarea
{
    resize: none;
    height: 120px;
    padding: 12px 18px;
}

.submit-btn
{
    height: 50px; width: 200px;
    border-radius: 3px;
    box-shadow: 0px 0px 6px rgb(0, 0, 0,0.12);
    transition: all 0.1s ease;
    background-color: #00c7ff;
    font-weight: 700;
    font-size: 17px;
    color: #ffffff;
    display: block;
    margin: 0 auto;
}

.submit-btn:hover { box-shadow: 0px 0px 12px rgb(0, 0, 0,0.2); }

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] { -moz-appearance: textfield; }

@media only screen and  (max-width: 1023px)
{
    .contact-wrapper { flex-wrap: wrap;  flex-direction: column;}

    form, .address-box
    {
        width: 100%;
        max-width: 440px;
        margin: 50px auto 0;
    }

    .form-element { max-width: 450px; margin-left: auto;  margin-right: auto; }
}

@media only screen and  (max-width: 600px)
{
    form, .address-box
    {
        border-radius: 0;
        width: 100%;
        padding: 50px 0;
        box-shadow: none;
        background-color: transparent;
        height: auto;
        margin: 0 auto;
    }

    form { padding-bottom: 0; }

    .submit-btn { width: 100%; }
}


</style>